import { Container } from './styles';
import githubIcon from '../../assets/github.svg';
import ScrollAnimation from 'react-animate-on-scroll';

export function Project() {
  return (
    <Container id="project">
      <h2>Recent Projects</h2>
      <div className="projects">
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/jgipson360/jira-langchain"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="GitHub" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Jira LangChain Automation Tool</h3>
              <p>
                Automated Jira ticket creation using LangChain and Jira Toolkit.
                Features intelligent LLM fallback with Claude/Gemini for natural
                language parsing, dynamic epic discovery, smart dependency
                linking, and robust multi-format parsing. Born from a real need
                to organize complex family projects with hundreds of
                interconnected tasks and dependencies.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>LangChain</li>
                <li>Jira API</li>
                <li>Claude/Gemini</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/jgipson360/hookedonaneedle"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="GitHub" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Hooked On A Needle</h3>
              <p>
                A custom WordPress theme and development environment for a
                handmade crochet and fiber arts online store. Built from scratch
                with WooCommerce integration, custom orders, email waitlist,
                light/dark mode, and a fully editable content system powered by
                Advanced Custom Fields. Includes Dockerized local dev, CI
                pipeline, and automated SFTP deployment.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>WordPress</li>
                <li>WooCommerce</li>
                <li>Tailwind CSS</li>
                <li>Docker</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}
